/** Rules the one-off send cards share with the server's checks. */

/** The subject and email the user may change on the card before Confirm. */
export type EmailEdits = { subject: string; body: string };

const PLACEHOLDER = /\{\{[^{}]*\}\}/g;

/**
 * The first `{{...}}` the email still holds, as the server finds it: a one-off
 * email isn't merged with a lead, so only `{{sender.signature}}` in the body
 * is filled and any other would be refused after Confirm.
 */
export function emailPlaceholder({ subject, body }: EmailEdits): string | null {
  for (const [value, allowed] of [
    [subject, []],
    [body, ['sender.signature']],
  ] as const) {
    for (const found of value.match(PLACEHOLDER) ?? []) {
      if (!(allowed as readonly string[]).includes(found.slice(2, -2).trim()))
        return found;
    }
  }
  return null;
}

/** The subject as the reply goes out: the server adds "Re: " unless it's there. */
export function replySubject(subject: string): string {
  return !subject || /^re:/i.test(subject) ? subject : `Re: ${subject}`;
}
